// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__XAF05","validationTips":"StatementDescriptor_validationTips__cC7ZV"};